/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_No_PaymentsInputs */

const en_settings_payments_no_payments = /** @type {(inputs: Settings_Payments_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet`)
};

/**
* | output |
* | --- |
* | "No payments yet" |
*
* @param {Settings_Payments_No_PaymentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_no_payments = /** @type {((inputs?: Settings_Payments_No_PaymentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_No_PaymentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_no_payments(inputs)
});
export { settings_payments_no_payments as "settings.payments.no_payments" }